import { useRef } from 'react'
import { messages } from './messages'
import { endpoints } from './endpoints'
import { WEBSOCKET_URL } from './constants'
import { generateRandomID, safelyParse } from './utils'

interface VitalAlertSocketProps {
  handleIncomingVitalAlerts: (message: any) => void
}

interface SocketData {
  createVitalAlertSocket: () => void
  sendMessageOnSocket: () => void
  closeProrithmWebSocket: () => void
}

const useVitalAlertSocket = ({
  handleIncomingVitalAlerts,
}: VitalAlertSocketProps): SocketData => {
  const alertSocketRef = useRef<WebSocket | null>(null)

  const dummyMessage = {
    session: 'keep-alive',
  }

  const createVitalAlertSocket = () => {
    const randomID = generateRandomID(4)
    const socket = new WebSocket(
      `${WEBSOCKET_URL}${endpoints?.vitalAlertSocket}${randomID}`
    )
    alertSocketRef.current = socket

    socket.onopen = function (event) {
      console.log(messages?.websocketConnection, event.type)
    }

    socket.onmessage = (event) => {
      const message = safelyParse(event.data)
      if (!message) return
      handleIncomingVitalAlerts(message)
    }

    socket.onerror = function (event) {
      console.error(messages?.websocketErrorObserved, event)
    }

    socket.onclose = function (event) {
      // Normal closure codes
      const normalCodes = [1000, 1001]

      if (!normalCodes.includes(event?.code)) {
        console.log(messages?.websocketReconnect)

        // Close existing socket if it's not already closed
        if (alertSocketRef?.current?.readyState !== WebSocket.OPEN) {
          try {
            alertSocketRef?.current?.close()
          } catch (e) {
            console.warn(messages?.websocketCloseError)
          }
          createVitalAlertSocket()
        }
      }
    }
  }

  const sendMessageOnSocket = () => {
    if (alertSocketRef.current?.readyState === WebSocket.OPEN) {
      alertSocketRef.current?.send(JSON.stringify(dummyMessage))
    } else {
      console.warn(messages?.websocketNotOpen)
    }
  }

  const closeProrithmWebSocket = () => {
    if (alertSocketRef?.current) {
      alertSocketRef?.current?.close()
      console.log(messages?.websocketConnectionClosed)
    }
  }

  return {
    createVitalAlertSocket,
    sendMessageOnSocket,
    closeProrithmWebSocket,
  }
}

export default useVitalAlertSocket
